ixModuleRouting("impactx.tender", {
    "/tender/:id/:useSetFilter?": {
        templateUrl: "modules/tender/templates/tender.html",
        controller: "TenderCtrl",
        controllerAs: "tenderCtrl",
        workspace: "shop",
    },
    "/tenderdetail/:id": {
        template: "<ixa-tender-detail></ixa-tender-detail>",
        templateUrl: "modules/tender/templates/tenderdetail.html",
        process: "ViewTenderDetail",
        controller: "TenderDetailCtrl",
        controllerAs: "tenderDetailCtrl",
        workspace: "content",
    },
    "/tenderlist": {
        template: "<ixa-tender-list></ixa-tender-list>",
        templateUrl: "modules/tender/templates/tenderlist.html",
        process: "ListTender",
        controller: "TenderListCtrl",
        controllerAs: "tenderListCtrl",
        workspace: "content",
    },
    "/tenderlotcsclist/:id?": {
        template: "<ixa-tenderlotcsc-list></ixa-tenderlotcsc-list>",
        templateUrl: "modules/tender/templates/tenderlotcsclist.tmpl.html",
        process: "ListTender",
        controller: "TenderLotCSCCtrl",
        controllerAs: "tenderLotCSCCtrl",
        workspace: "content",
    },
    "/tenderlotcscdetail/:id?": {
        template: "<ixa-tender-lot-csc-detail></ixa-tender-lot-csc-detail>",
        templateUrl: "modules/tender/templates/tenderlotcscdetail.html",
        process: "ViewTenderDetail",
        controller: "TenderLotCSCDetailCtrl",
        controllerAs: "tenderLotCSCDetailCtrl",
        workspace: "content",
    },
    "/mostusedtenders": {
        template: "<ixa-most-used-tender-list></ixa-most-used-tender-list>",
        templateUrl: "modules/tender/templates/tendergrid.tmpl.html",
        process: "MostUsedTenders",
        controller: "MostUsedTenderCtrl",
        controllerAs: "mostUsedTenderCtrl",
        workspace: "shop",
    },
    "/newesttenders": {
        template: "<ixa-newest-tender-list></ixa-newest-tender-list>",
        templateUrl: "modules/tender/templates/tendergrid.tmpl.html",
        controller: "NewestTenderCtrl",
        controllerAs: "newestTenderCtrl",
        workspace: "shop",
    },
    "/tendertreatmenttypelist": {
        template: "<ixa-tendertreatmenttype-list></ixa-tendertreatmenttype-list>",
        templateUrl:
            "modules/tender/templates/tendertreatmenttypelist.tmpl.html",
        process: "TenderTypeLists",
        controller: "TenderTreatmentTypeListCtrl",
        controllerAs: "tenderTreatmentTypeListCtrl",
        workspace: "content",
    },
    "/tendertreatmenttype/:id": {
        template: "<ixa-ttt-dialog></ixa-ttt-dialog>",
        process: "TenderTypeEdit",
        workspace: "content",
    },
    "/tendercontracttypelist": {
        template: "<ixa-tendercontracttype-list></ixa-tendercontracttype-list>",
        templateUrl:
            "modules/tender/templates/tendercontracttypelist.tmpl.html",
        process: "TenderTypeLists",
        controller: "TenderContractTypeListCtrl",
        controllerAs: "tenderContractTypeListCtrl",
        workspace: "content",
    },
    "/mainprocurementgrouplist": {
        template: "<ixa-main-procurement-group-list></ixa-main-procurement-group-list>",
        process: "MainProcurementGroup",
        workspace: "admin",
    },
    "/mainprocurementgroup/:id": {
        template: "<ixa-main-procurement-group></ixa-main-procurement-group>",
        process: "MainProcurementGroup",
        workspace: "admin",
    },
});
